import FormPublish from '@apps/truevail/admin/components/form_publish'
import FormToken from '@apps/forms/admin/tokens/form'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Forms)',
  collection: {
    endpoint: `/api/admin/truevail/admin/advisors/${props.advisor.id}/forms`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true, format: FormToken }
    ],
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      svg: 'square_check',
      title: 't(No Forms)',
      text: 't(You have not yet created any forms for this advisor)',
      buttons: [
        { 
          label: 't(Publish Advisor Form)',
          modal: <FormPublish advisor={ props.advisor } entity="admin" />
        }
      ]
    },
    entity: 'form',
    onClick: (record) => context.host.window.open(`/${props.advisor.team.subdomain}/forms/forms/${record.id}`)
  },
  task: {
    svg: 'plus',
    tooltip: 't(Publish Advisor Form)',
    modal: <FormPublish advisor={ props.advisor } entity="admin" />
  }
})

export default Panel(null, mapPropsToPanel)
